import type { ModelTestLogStep, ModelTestLogStepStatus } from "@vida/currents-core";

function statusIcon(status: ModelTestLogStepStatus): string {
  switch (status) {
    case "ok":
      return "✓";
    case "error":
      return "✕";
    case "warn":
      return "!";
    case "running":
      return "…";
    default:
      return "○";
  }
}

type Props = {
  steps: ModelTestLogStep[];
  imageUrl?: string | null;
  mime?: string | null;
  prompt?: string | null;
  durationMs?: number | null;
  costCents?: number | null;
};

export function ModelTestTracePanel({
  steps,
  imageUrl,
  mime,
  prompt,
  durationMs,
  costCents,
}: Props) {
  if (steps.length === 0 && !imageUrl && !prompt) {
    return null;
  }

  return (
    <div className="model-test-trace" style={{ marginTop: "1rem" }}>
      {steps.length > 0 && (
        <>
          <div className="mission-io-title">Log step e check</div>
          <ol className="model-test-step-list">
            {steps.map((step) => (
              <li
                key={`${step.id}-${step.at ?? ""}`}
                className={`model-test-step model-test-step--${step.status}`}
              >
                <span className="model-test-step-icon" aria-hidden>
                  {statusIcon(step.status)}
                </span>
                <div className="model-test-step-body">
                  <div className="model-test-step-label">{step.label}</div>
                  {step.detail && (
                    <pre className="model-test-step-detail">{step.detail}</pre>
                  )}
                  {step.at && (
                    <time className="muted model-test-step-time" dateTime={step.at}>
                      {new Date(step.at).toLocaleTimeString("it-IT")}
                    </time>
                  )}
                </div>
              </li>
            ))}
          </ol>
        </>
      )}

      {(prompt || durationMs != null || costCents != null) && (
        <div className="mission-io-section" style={{ marginTop: "0.75rem" }}>
          <div className="mission-io-title">Risultato</div>
          {prompt && <pre className="mission-io-value">{prompt}</pre>}
          {(durationMs != null || costCents != null) && (
            <p className="muted">
              {durationMs != null && <span>{durationMs} ms</span>}
              {costCents != null && <span>{durationMs != null ? " · " : ""}{costCents} cent</span>}
              {mime && <span> · {mime}</span>}
            </p>
          )}
        </div>
      )}

      {imageUrl && (
        <div className="model-test-preview" style={{ marginTop: "0.75rem" }}>
          <div className="mission-io-title">Anteprima immagine</div>
          <img src={imageUrl} alt="Output generazione MODEL" className="model-test-preview-img" />
        </div>
      )}
    </div>
  );
}
